import addDays from 'date-fns/addDays';
import { BaseProps } from '../components/SearchResults';
import parseToDateString from '../constants/parseToDateString';
import getUpcomingDay from './getUpcomingDay';

const getArrivalDate = () => parseToDateString(getUpcomingDay(5));
const getDepartureDate = () => parseToDateString(addDays(new Date(getArrivalDate()), 3));

const getLastMinuteOptions = (): BaseProps => ({
    startParams: {
        amountAdults: 2,
        arrivalDate: getArrivalDate(),
        departureDate: getDepartureDate(),
    },
});

export default getLastMinuteOptions;
